const LABS_PREF = 'fslabs.labs'

const flagsWithPrefs = {
  EXPOHALL: 'rootstech_expohall',
  PREVIEW: 'rootstech_preview',
  SITE_EXPERIENCE: 'rootstech_site_experience',
  CHAT_AUA_BUTTON: 'messaging_chat_aua_button',
  CHAT_ASKUSANYTHING: 'messaging_chat_askUsAnything',
  CHAT_HELPER: 'messaging_chat_helper',
  DAY_THEME: 'cpt_rootstech_day_theme',
}

const flagsWithoutPrefs = {
  ADMIN: 'cpt_rootstech_admin',
  BANNER_MAINTENANCE: 'rootstech_bannerMaintenance',
  CALL_FOR_PRESENTATIONS: 'rootstech_callForPresentations',
  CHAT: 'rootstech_chat',
  DASHBOARD: 'rootstech_dashboard',
  EMBEDDED_CHAT_FALLBACK: 'messaging_chat_show_embedded_fallback_for_all',
  NEW_PLAYLIST_STATE: 'cpt_rootstech_new_playlist_state',
  EMBEDDED_CHAT: 'rootstech_embedded_chat',
  FORCE_LIVE: 'rootstech_force_live',
  HISTORY_DELETE: 'rootstech_history_delete',
  HOMELAND_SESSIONS: 'rootstech_ancestral_homeland_sessions',
  LATAM_EL_CAMINO: 'rootstech_latam_el_camino',
  LATAM_CONFERENCE_EXPERIENCE: 'rootstech_latam_conference_experience',
  LOG_GRAPHQL_DETAILS: 'rootstech_log_graphql_details',
  MY_LIKES: 'cpt_rootstech_my_likes',
  NO_SESSION_COUNTDOWN: 'rootstech_no_session_countdown',
  PREVIEW_PATH_MAPPING: 'cpt_rootstech_preview_path_mapping',
  PERSIST_QUERIES: 'rootstech_persist_queries',
  QA_OPTIONS: 'rootstech_qa_options',
  QA_SCHEDULED_PLAYER: 'rootstech_qa_scheduled_player',
  RAR: 'rootstech_rar',
  REMOVE_SESSION_FROM_SCHEDULE_CONFIRM: 'cpt_rootstech_remove_session_from_schedule_confirm',
  SCHEDULE: 'rootstech_schedule',
  SPEAKER_MIXED_LOCALES: 'cpt_rootstech_speaker_mixed_locales',
  CALL_FOR_EXHIBITORS: 'cpt_rootstech_callForExhibitors',
  STORE: 'rootstech_store',
  VENDOR_CHAT: 'rootstech_vendor_chat',
  VOLUNTEER: 'rootstech_volunteer',
  EXTERNAL_NAVIGATION_OVERLAY: 'rootstech_external_nav_overlay',
  ONION_SKIN: 'rootstech_onion_skin',
  TOP_RATED_SESSIONS: 'cpt_rootstech_top_rated_sessions',
  TOP_WATCHED_SESSIONS: 'cpt_rootstech_top_watched_sessions',
  EARLY_BIRD_PRICING: 'cpt_rootstech_early_bird_pricing',
  REGISTRATION_BANNER: 'cpt_rootstech_registration_banner',
  ZION_CAROUSEL: 'cpt_rootstech_zion_carousel',
  WATCH_LATER_CAROUSEL: 'cpt_rootstech_watch_later_carousel',
  SYLLABI_PAGE: 'cpt_rootstech_syllabi_page',
  SCHEDULE_SAVE: 'cpt_rootstech_schedule_save',
}

export const FLAGS = {
  ...flagsWithPrefs,
  ...flagsWithoutPrefs,
}

const flagsConfig = {
  labsPref: LABS_PREF,
  flagsWithPrefs: Object.values(flagsWithPrefs),
  flagsWithoutPrefs: Object.values(flagsWithoutPrefs),
}

export default flagsConfig
